import * as St from './PunchHolesGroup.styles';

const PunchHolesGroup = ({ children }: { children: JSX.Element[] }) => (
  <St.Container>
    {children.map((child, index) => (
      <St.Item key={index}>
        {child}
        {index < children.length - 1 && <St.Separator />}
      </St.Item>
    ))}
  </St.Container>
);

export default PunchHolesGroup;
